import ReactDom from 'react-dom';

import { Icon as BlueIcon } from '@blueprintjs/core';
import { getUpdateAffectedItems } from '@services/queries/updates';
import { useQuery } from 'react-query';
import { AffectedItemsDialogLoading } from './AffectedItemsDialog.loading';
import {
  Close,
  Container,
  Divider,
  Head,
  Header,
  Items,
  Overlay,
  Table,
  Title,
} from './AffectedItemsDialog.styles';
import { AffectedItem } from './AffectedItem/AffectedItem';

interface IAffectedItemsDialog {
  open: boolean;
  onClose: () => void;
  updateId: string;
}

export const AffectedItemsDialog = ({
  open,
  onClose,
  updateId,
}: IAffectedItemsDialog) => {
  const portalDiv = document.getElementById('portal');

  const { data, isLoading, isError } = useQuery(
    ['updates', updateId, 'affectedItems'],
    () => getUpdateAffectedItems({ updateId }),
  );

  return open && portalDiv
    ? ReactDom.createPortal(
        <Overlay>
          <Container>
            <Header>
              <Title>Affected Items</Title>
              <Close onClick={onClose}>
                <BlueIcon icon="cross" color="#8F95B2" />
              </Close>
            </Header>
            <Divider />

            <Table>
              <Head>Name</Head>
              <Head>Manufacturer</Head>
              <Head>Serial #</Head>
              <Head>Tags</Head>
            </Table>

            <Items>
              {!isLoading && !isError && data ? (
                data.map(item => <AffectedItem key={item.id} item={item} />)
              ) : (
                <AffectedItemsDialogLoading />
              )}
            </Items>
          </Container>
        </Overlay>,
        portalDiv,
      )
    : null;
};
